import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/articleSearch",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/Home"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },

  {
    path: "/articleSearch",
    name: "articleSearch",
    component: () => import("@/views/ArticleSearch"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/literatureSearch",
    name: "literatureSearch",
    component: () => import("@/views/ArticleSearch/literature"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/article",
    name: "Article",
    component: () => import("@/views/Article"),
    meta: {
      keepAlive: false, // 需要被缓存
      isBack: false,
    },
  },
  {
    path: "/homeDetail",
    name: "homeDetail",
    component: () => import("@/views/HomeDetail"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/articleDetail",
    name: "articleDetail",
    component: () => import("@/views/ArticleDetail"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/mine",
    name: "mine",
    component: () => import("@/views/Mine"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/school_login",
    name: "school_login",
    component: () => import("@/views/Login/school_login"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/asp_login",
    name: "asp_login",
    component: () => import("@/views/Login/asp_login"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/fourfour",
    name: "fourfour",
    component: () => import("@/views/fourfour"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/lg",
    name: "denglu",
    component: () => import("@/views/denglu"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/aiHelp",
    name: "AiHelp",
    component: () => import("@/views/AiHelp"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/Help"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/topicsearch",
    name: "topicsearch",
    component: () => import("@/views/TopicSearch"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/subject",
    name: "subject",
    component: () => import("@/views/subject"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/upload",
    name: "upload",
    component: () => import("@/views/upload"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/video",
    name: "video",
    component: () => import("@/views/Video"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/analysis",
    name: "analysis",
    component: () => import("@/views/Analysis"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/intellIndex",
    name: "intellIndex",
    component: () => import("@/views/Article/intellIndex"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/author",
    name: "author",
    component: () => import("@/views/Author"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/authorDetail",
    name: "authorDetail",
    component: () => import("@/views/Author/detail"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/pdf",
    name: "pdf",
    component: () => import("@/views/Pdf"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/trend",
    name: "trend",
    component: () => import("@/views/Trend"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/trendList",
    name: "trendList",
    component: () => import("@/views/Trend/list"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/News"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/answers_list",
    name: "answers_list",
    component: () => import("@/views/AiAnswers/searchlist"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/denglu/register"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/findpwd",
    name: "findpwd",
    component: () => import("@/views/denglu/findpwd"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/clearToken",
    name: "clearToken",
    component: () => import("@/views/denglu/cleartoken"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/checktoken",
    name: "checktoken",
    component: () => import("@/views/denglu/checktoken"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/info/index"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/infoDetail",
    name: "infoDetail",
    component: () => import("@/views/info/detail"),
    meta: {
      keepAlive: false, // 需要被缓存
    },
  },
  /**
   * 学科知识库路由
   */
  {
    path: "/subjectGateway/index",
    name: "subjectGateway",
    component: () => import("@/views/SubjectGateway"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/journal",
    name: "journal",
    component: () => import("@/views/SubjectGateway/journal"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/news",
    name: "subjectGatewayNews",
    component: () => import("@/views/SubjectGateway/news"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/author",
    name: "subjectGatewayAuthor",
    component: () => import("@/views/SubjectGateway/author"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/topic",
    name: "topic",
    component: () => import("@/views/SubjectGateway/topic"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/literature",
    name: "literature",
    component: () => import("@/views/SubjectGateway/literature"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/dynamic",
    name: "dynamic",
    component: () => import("@/views/SubjectGateway/dynamic"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/subjectGateway/list",
    name: "list",
    component: () => import("@/views/SubjectGateway/numList"),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

function setScrollTop(top) {
  [document.getElementById("subapp-container"), document.querySelector(".view"), document.scrollingElement, document.documentElement, document.body].filter(Boolean).forEach(element => {
    element.scrollTop = top;
  });
  window.scrollTo(0, top);
}

router.afterEach(to => {
  if (to.name !== "homeDetail") {
    return;
  }

  setTimeout(() => setScrollTop(0), 0);
  setTimeout(() => setScrollTop(0), 100);
});

export default router;
